<template>
  <div class="container-base mt-32 pb-32">
    <div class="flex pb-16">
      <TextIcon
        icon="star"
        :text="$t('quickAcess.title')"
        icon-class="!text-primary-pure -mt-4"
        :icon-props="{ size: '2.25rem' }"
      />
    </div>

    <div class="flex gap-16">
      <q-item
        v-for="acesso in acessos"
        :key="acesso.id"
        clickable
        class="min-w-[324px] flex-1 h-[180px] bg-white item-home rounded-md justify-center inline-flex flex-col p-16 border border-neutral-100/10 cursor-pointer"
        :class="acesso.class"
        :href="acesso.href"
        @click="(e) => acesso?.onClick?.(e)"
      >
        <div
          class="w-48 h-48 bg-primary-pure/10 rounded-lg grid place-items-center text-primary-pure"
        >
          <q-icon :name="acesso.icone" size="1.5rem" />
        </div>

        <div class="pt-16 flex flex-nowrap justify-between">
          <div class="text-pararaphy-2">
            <p :title="acesso.titulo" class="two-lines text-headline-1 pb-12">
              {{ acesso.titulo }}
            </p>
            <p class="text-pararaphy-2 text-neutral-60">{{ acesso.desc }}</p>
          </div>
        </div>
      </q-item>
    </div>
  </div>
</template>

<script setup>
import { computed, inject, onMounted } from 'vue'
import { useSessionStorage, useStorage } from '@vueuse/core'
import TextIcon from 'components/Text/TextIcon.vue'

import { paramsString } from 'store/params.store'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const modalAtencaoStorage = useSessionStorage('modalAtencaoStorage', {
  home: false,
})

const { modalParametrosRef, modalAtencaoRef } = inject('modal')

const acessos = computed(() => [
  {
    id: 1,
    icone: 'svguse:#icon_requests',
    titulo: t('quickAcess.request.title'),
    desc: t('quickAcess.request.description'),
    href: 'solicitacoes' + paramsString.value,
  },
  {
    id: 2,
    icone: 'svguse:#icon_arquivos',
    class: 'hidden',

    titulo: t('quickAcess.repositorie.title'),
    desc: t('quickAcess.repositorie.description'),
    href: 'repositorios' + paramsString.value,
  },
  {
    id: 3,
    icone: 'svguse:#icon_params',
    class: 'hidden',

    titulo: t('quickAcess.parameter.title'),
    desc: t('quickAcess.parameter.description'),
    onClick: () => {
      modalParametrosRef.value.open()
    },
  },
])

onMounted(() => {
  // if (!modalAtencaoStorage.value.home) {
  //   modalAtencaoStorage.value.home = true
  //   modalAtencaoRef.value.open({ local_exibicao: 'acesso_rapido' })
  // }
})
</script>

<style lang="scss" scoped></style>
